// 通貨フォーマット用のユーティリティ関数
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0';
  }
  try {
    const numAmount = Number(amount);
    if (isNaN(numAmount)) {
      return '0';
    }
    return `${numAmount.toLocaleString()}`;
  } catch (error) {
    console.error('Error formatting currency:', error, 'amount:', amount);
    return '0';
  }
};

// 数値フォーマット用のユーティリティ関数
export const formatNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }
  try {
    const numValue = Number(num);
    if (isNaN(numValue)) {
      return '0';
    }
    return numValue.toLocaleString();
  } catch (error) {
    console.error('Error formatting number:', error, 'num:', num);
    return '0';
  }
};

// 日付フォーマット用のユーティリティ関数
export const formatDate = (dateString) => {
  if (!dateString) {
    return '';
  }
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '';
    }
    return date.toLocaleDateString('ja-JP');
  } catch (error) {
    console.error('Error formatting date:', error, 'dateString:', dateString);
    return '';
  }
};

// 日時フォーマット用のユーティリティ関数
export const formatDateTime = (dateString) => {
  if (!dateString) {
    return '';
  }
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '';
    }
    return date.toLocaleString('ja-JP');
  } catch (error) {
    console.error('Error formatting datetime:', error, 'dateString:', dateString);
    return '';
  }
};